import state from './moduleRolesAndPermissionsState.js';
import mutations from './moduleRolesAndPermissionsMutations.js';
import actions from './moduleRolesAndPermissionsActions.js';
import getters from './moduleRolesAndPermissionsGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
